import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import fetchData from '../../../api/fetchData';
import { useTranslation } from 'react-i18next';

function AdminReviewEditForm({ onContentUpdated }) {
  const { reviewId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Состояния для полей формы
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isApproved, setIsApproved] = useState(false);
  const [message, setMessage] = useState('');
  const [languageCode, setLanguageCode] = useState(''); 


  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ message: '', type: '' });

  useEffect(() => {
    const loadReviewData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetchData(`/admin/reviews/admin_get_review.php?id=${reviewId}`, 'GET', null, { credentials: 'include' });
        if (response && response.status === 'success' && response.item) {
          const fetchedItem = response.item;
          setName(fetchedItem.name || '');
          setEmail(fetchedItem.email || '');
          setIsApproved(fetchedItem.is_approved == 1);
          setMessage(fetchedItem.message || '');
          setLanguageCode(fetchedItem.language_code || '');
        } else {
          setError(response?.message || 'Не удалось загрузить данные отзыва.');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadReviewData();
  }, [reviewId]); 

  const handleSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    setSaveStatus({ message: '', type: '' });

    const payload = {
      reviewId: reviewId,
      name: name,
      email: email,
      is_approved: isApproved,
      message: message,
      language_code: languageCode 
    };
    
    try {
      const response = await fetchData('/admin/reviews/admin_save_review.php', 'POST', payload, { credentials: 'include' });
      if (response && response.status === 'success') {
        setSaveStatus({ message: response.message, type: 'success' });
        if (onContentUpdated) onContentUpdated();
      } else {
        setSaveStatus({ message: response?.message || 'Ошибка', type: 'error' });
      }
    } catch (err) {
      setSaveStatus({ message: err.message, type: 'error' });
    } finally {
      setIsSaving(false);
      setTimeout(() => setSaveStatus({ message: '', type: '' }), 5000);
    }
  };

  if (loading) return <p>{t('messages.loading')}</p>;
  if (error) return <p>Ошибка: {error}</p>;

  return (
    <div className="admin-review-edit-form">
      <h3>{t('admin.reviews.editFormTitle', { id: reviewId })}</h3>
      <p><strong>{t('admin.reviews.languageOfReview', 'Язык отзыва:')}</strong> {languageCode.toUpperCase()}</p>

      <form onSubmit={handleSave}>
        <fieldset>
          <legend>{t('admin.reviews.authorInfoLegend', 'Информация об авторе')}</legend>
          <div>
            <label htmlFor="reviewName">{t('reviewsForm.nameLabel')}:</label>
            <input type="text" id="reviewName" value={name} onChange={e => setName(e.target.value)} />
          </div>
          <div>
            <label htmlFor="reviewEmail">{t('reviewsForm.emailLabel')}:</label>
            <input type="email" id="reviewEmail" value={email} onChange={e => setEmail(e.target.value)} />
          </div>
          <div>
            <label>
              <input type="checkbox" checked={isApproved} onChange={e => setIsApproved(e.target.checked)} />
              {t('admin.reviews.statusApproved', 'Одобрен')}
            </label>
          </div>
        </fieldset>

        <fieldset>
          <legend>{t('reviewsForm.reviewLabel')}</legend>
          <textarea 
            id="reviewMessage" 
            value={message} 
            onChange={e => setMessage(e.target.value)} 
            rows="8" 
            style={{width: '100%'}} 
          />
        </fieldset>
        
        <button type="submit" disabled={isSaving} style={{ marginTop: '10px' }}>
          {isSaving ? t('admin.buttons.saving') : t('admin.buttons.saveSimple', 'Сохранить')}
        </button>
      </form>
      {saveStatus.message && <p className={`form-status-message ${saveStatus.type}`}>{saveStatus.message}</p>}
    </div>
  );
}

export default AdminReviewEditForm;